import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const AuthzPermission = React.lazy(() =>
    import('../AuthzPermission')
);
const authzPermissionRoutesRegistry = [
    {
        path: PAGE_URL.AUTHZ_PERMISSION_PAGE,
        element: <AuthzPermission />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default authzPermissionRoutesRegistry;
